import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const dataModuleActions = createDataModuleActions(
    'FETCH_GENERAL_ACCOUNT_SUMMARY',
);
export const fetchGeneralAccountSummary = dataModuleActions.dataRequest;
export const replaceGeneralAccountSummary = dataModuleActions.dataSuccess;
export const fetchGeneralAccountSummaryError = dataModuleActions.dataError;
export const resetGeneralAccountSummary = dataModuleActions.dataReset;
